import React from 'react';
import {styled} from '@mui/material/styles';
import MaterialInputLabel from '@mui/material/InputLabel';
import type {InputLabelProps as MaterialInputLabelProps} from '@mui/material/InputLabel';

export interface InputLabelProps extends Omit<MaterialInputLabelProps, 'variant'> {
    /**
     * Visually hiding the label, not be confused with the WARIA 'hidden' attribute.
     * @default false
     */
    hiddenLabel?: boolean;
}

const StyledInputLabel = styled(MaterialInputLabel)(({theme}) => ({
    color: theme.tokens.FuelColorGray900,
    fontSize: theme.typography.button.fontSize,
    fontWeight: theme.typography.button.fontWeight,
    marginBottom: theme.spacing(1),
    '&.Mui-focused': {
        color: theme.tokens.FuelColorTextPrimary
    },
    '&.MuiInputLabel-shrink': {
        transform: 'none',
        position: 'relative',
        height: 'auto',
        overflow: 'hidden',
        lineHeight: theme.spacing(5),
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    '&.Mui-error': {
        color: theme.tokens.FuelColorGray900
    },
    '& .MuiInputLabel-asterisk': {
        color: theme.palette.error.main
    }
}));

export const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(
    (
        {
            children,
            hiddenLabel,
            sx,
            ...props
        },
        ref
    ) => {
        return (
            <StyledInputLabel
                {...props}
                ref={ref}
                shrink={true}
                sx={{
                    display: hiddenLabel ? 'none' : 'block',
                    ...sx
                }}
            >
                {children}
            </StyledInputLabel>
        );
    });

InputLabel.displayName = 'InputLabel';
